import LotAttachmentsDialog from "./LotAttachmentsDialog";

export default LotAttachmentsDialog;